// ImageCard.js
import React from 'react';
import {
  Box,
  Button,
  Paper,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';

const ImageCard = ({
  imgData,
  index,
  onFieldChange,
  onRemove,
  isExisting = false,
  baseUrl = '',
  handleSync = () => {}
}) => {
  const imageSrc = isExisting
    ? `${baseUrl}${imgData.imageUrl}`
    : URL.createObjectURL(imgData.file);

  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
      <Box display="flex" gap={2} alignItems="center" mb={1}>
        {/* Image Preview */}
        <img
          src={imageSrc}
          alt={`preview-${index}`}
          width={64}
          height={64}
          style={{ objectFit: 'cover', borderRadius: 8 }}
        />

        {/* File Info, Delete, and Sync Buttons */}
        <Box flexGrow={1}>
          <Typography
            variant="body2"
            noWrap
            sx={{
              maxWidth: '160px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {isExisting
              ? imgData.imageUrl?.split('/').pop()
              : imgData.file.name}
          </Typography>

          <Box display="flex" alignItems="center" mt={1}>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => onRemove(index, isExisting)}
            >
              Delete
            </Button>

            {/* Sync Button */}
            <Tooltip title="Sync Image with WooCommerce" placement="top" arrow>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => handleSync(imgData)}
                sx={{ minWidth: '40px', height: '30px', p: 1, ml: 1 }}
              >
                <SyncIcon fontSize="small" />
              </Button>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      {/* Show editable fields only if image is not already existing */}
      {!isExisting && (
        <>
          <TextField
            label="Alt Text"
            size="small"
            value={imgData.alt_text}
            onChange={(e) =>
              onFieldChange(index, 'alt_text', e.target.value, isExisting)
            }
            fullWidth
            margin="dense"
          />
          <TextField
            label="Description"
            size="small"
            value={imgData.description}
            onChange={(e) =>
              onFieldChange(index, 'description', e.target.value, isExisting)
            }
            fullWidth
            margin="dense"
          />
          <TextField
            label="Caption"
            size="small"
            value={imgData.caption}
            onChange={(e) =>
              onFieldChange(index, 'caption', e.target.value, isExisting)
            }
            fullWidth
            margin="dense"
          />
          <TextField
            label="Tag"
            size="small"
            value={imgData.tag}
            onChange={(e) =>
              onFieldChange(index, 'tag', e.target.value, isExisting)
            }
            fullWidth
            margin="dense"
          />
        </>
      )}
    </Paper>
  );
};

export default ImageCard;
